'use strict';

var App = require('app');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');

var ValueSelectionDialogView = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/value_select'),

    events: {
        'click a#js-save': 'saveClicked',
    },

    initialize: function (options) {
        this.options = options;
        this.options.title = options.title || i18n.TR('Werte auswählen');
        this.titleAvailableItems = options.titleAvailableItems || i18n.TR('Verfügbar');
        this.titleChosenItems = options.titleChosenItems || i18n.TR('Ausgewählt');
    },

    serializeData: function () {
        return this.options;
    },

    saveClicked: function (e) {
        e.preventDefault();
        App.hideModal();
        this.options.save_cb($('#col_multi_select').val() || []);
    },

    onAttach: function () {
        this.initializeMultiSelect();
    },

    onRender: function () {
        this.initializeMultiSelect();
    },

    initializeMultiSelect: function () {
        Misc.initializeMultiSelect('#col_multi_select', this.titleAvailableItems, this.titleChosenItems);
    },
});

module.exports = ValueSelectionDialogView;
